import { QIcon_arrow_left } from '@repo/icons/index'
import { useEffect } from 'react'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import urls from '../../../../../modules/urls'
import { COLORS } from '../../../../../modules/vars'
import { useCafSidePopup } from '../../common/CafSidePopup'
import SidePopupBody from './components/Body'

export interface SidePopupBodyProps {
  headerProps: SidePopupHeaderProps
  children: JSX.Element | JSX.Element[] | string | string[]
}
export interface SidePopupHeaderProps {
  title: string | JSX.Element
  onClose: () => void
  SubIcon?: any
  onClickSubIcon?: any
}
const DEFAULT_PROPS = {
  hFull: true,
  bgWhite: true,
  maxW: 512,
  noTopSide: true,
  overlayClose: true,
}
const useCafRingleTipSidePopup = (useBackIcon = false) => {
  const router = useAppRouter()
  const sidePopup = useCafSidePopup()
  const { t } = useTranslation()
  const { lessonId, tab, highlightId, tipTag, startDate, endDate } = router.query
  const popupId = `caf_tip_${tipTag}`
  const isStatistic = router.asPath.includes('/my-ringle/ai-analysis')
  const onClose = () => {
    if (isStatistic) {
      router.push(urls.student.newPortal.myRingle.AIAnalysis.asTagBack(tab, startDate, endDate, tipTag))
    } else {
      router.push(urls.student.newPortal.lessons.reviewDetail.asCaf(lessonId, tab))
    }
  }
  const goBack = () => {
    if (isStatistic) {
      router.push(urls.student.newPortal.myRingle.AIAnalysis.asTagBack(tab, startDate, endDate, tipTag))
    } else {
      router.push(urls.student.newPortal.lessons.reviewDetail.asCafTagAndId(lessonId, tab, tipTag, highlightId))
    }
  }
  useEffect(() => {
    if (+tipTag >= 0) {
      const title = t(n_caf.highlight[`category${tipTag}`])
      sidePopup.show({
        ...DEFAULT_PROPS,
        id: popupId,
        body: (
          <SidePopupBody
            headerProps={{
              title: (
                <div className="flex flex-row items-center justify-start text-[20px] font-bold text-black">
                  {useBackIcon && (
                    <QIcon_arrow_left width={24} height={24} className="mr-[8px] cursor-pointer" onClick={goBack} />
                  )}
                  {title}
                </div>
              ),
              onClose: onClose,
            }}
          >
            <div className="flex w-full flex-col items-start justify-start pr-[68px]">
              <Content tag={+tipTag} />
            </div>
          </SidePopupBody>
        ),
        bgColor: COLORS.GRAY50,
        noScrollbar: false,
        onClose: onClose,
      })
    }
  }, [tipTag])
}

interface ContentProps {
  tag: number
}
const Content = ({ tag }: ContentProps) => {
  const { t } = useTranslation()
  if (isNaN(tag)) return <div className="w-full break-all bg-gray-50 px-[12px]"></div>
  const arr = [1, 2, 3, 4, 5]
  return (
    <div className="w-full rounded-[5px] border border-gray-200 bg-white p-[16px]">
      {arr.map((item) => {
        const isExist = !!t(n_caf.tip[`highlight${tag}`]) || !!t(n_caf.tip[`highlight${tag}`][`title${item}`])
        if (!isExist) return null
        return (
          <div key={item}>
            <div className="text-16 mb-4 font-bold text-purple-500">
              {t(n_caf.tip[`highlight${tag}`][`title${item}`])}
            </div>
            <div className="text-14 mb-32">{t(n_caf.tip[`highlight${tag}`][`body${item}`])}</div>
          </div>
        )
      })}
    </div>
  )
}

export default useCafRingleTipSidePopup
